<ng-container *transloco="let t; prefix: 'fuelReconciliation.uploadPreferenceModal'">
<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">{{ t('title') }}</h5>
    <button type="button" class="btn-close" [attr.aria-label]="'common.close' | transloco" (click)="closeModal()"></button>
  </div>

  <div class="modal-body">
    <form #uploadPreferenceForm="ngForm">
      <div class="row g-3">

        <div class="col-md-6">
          <label for="date" class="form-label">{{ t('dateColumn') }}</label>
          <input type="number" id="date" class="form-control" [(ngModel)]="uploadPreference.dateColumn"
            name="dateColumn">
        </div>
        <div class="col-md-6">
          <label for="asset" class="form-label">{{ t('assetColumn') }}</label>
          <input type="number" id="asset" class="form-control" [(ngModel)]="uploadPreference.assetColumn"
            name="assetColumn">
        </div>

        <div class="col-md-6">
          <label for="amount" class="form-label">{{ t('amountColumn') }}</label>
          <input type="number" id="amount" class="form-control" [(ngModel)]="uploadPreference.volumeColumn"
            name="amountColumn">
        </div>
        <div class="col-md-6">
          <label for="cost" class="form-label">{{ t('costColumn') }}</label>
          <input type="number" id="cost" class="form-control" [(ngModel)]="uploadPreference.amountColumn"
            name="costColumn">
        </div>

        <div class="col-md-6">
          <label for="start" class="form-label">{{ t('startRow') }}</label>
          <input type="number" id="start" class="form-control" [(ngModel)]="uploadPreference.startRow" name="startRow">
        </div>
        <div class="col-md-6">
          <div class="d-flex align-items-center gap-1 mb-1">
            <label for="start" class="form-label">{{ t('costTypeColumn') }}</label>
            <ng-template #htmlContent>
              <div [innerHTML]="infoCostTypeMessage"></div>
            </ng-template>

            <div [ngbTooltip]="htmlContent" [animation]="true">
              <svg width="14px" height="14px" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.26424 1.33301C4.60557 1.33301 1.62891 4.32367 1.62891 7.99967C1.62891 11.6757 4.61957 14.6663 8.29557 14.6663C11.9716 14.6663 14.9622 11.6757 14.9622 7.99967C14.9622 4.32367 11.9576 1.33301 8.26424 1.33301ZM8.96224 11.333H7.62891V9.99967H8.96224V11.333ZM8.96224 8.66634H7.62891V4.66634H8.96224V8.66634Z"
                  fill="#FF7F00" />
              </svg>
            </div>
          </div>
          <input type="number" id="start" class="form-control" [(ngModel)]="uploadPreference.amountTypeColumn"
            name="amountTypeColumn">
        </div>
        <div class="col-md-6" [class.dropdown-active]="showCurrencyDropdown">
          <label for="currency" class="form-label">{{ t('currency') }}</label>
          <div class="amount-currency-input-group">
            <div class="d-flex align-items-center currency-selector dropdown-toggle"
              (click)="toggleCurrencyDropdown($event)">
              <div class="d-flex align-items-center gap-2">
                <app-country-flag [countryCode]="selectedCurrency?.code || ''" [name]="selectedCurrency?.name || ''"
                  [size]="18" [rounded]="true"></app-country-flag>
                <span class="currency-code-display">
                  {{ selectedCurrency?.code || t('selectCurrency') }}
                </span>
              </div>

              <svg class="dropdown-arrow" width="12" height="8" viewBox="0 0 12 8" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M2 2L6 6L10 2" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>

            <div class="currency-dropdown-menu" *ngIf="showCurrencyDropdown" (click)="$event.stopPropagation()">
              <div class="currency-search-wrapper">
                <div class="search-container">
                  <input type="text" class="currency-search-input" [placeholder]="t('searchCurrency')"
                    [(ngModel)]="currencySearchTerm" name="currencySearch" (ngModelChange)="filterCurrencies()"
                    (click)="$event.stopPropagation()" #currencySearchInput />
                </div>
              </div>
              <ul class="currency-list">
                <li *ngIf="isCurrenciesLoading" class="no-results">
                  {{ t('loadingCurrencies') }}
                </li>
                <ng-container *ngIf="!isCurrenciesLoading">
                  <li *ngFor="let currency of filteredCurrencies" class="currency-item"
                    [class.selected]="selectedCurrency?.code === currency.code" (click)="selectCurrency(currency)">
                    <div class="currency-item-content">
                      <app-country-flag [countryCode]="currency.code" [name]="currency.name"
                        [rounded]="true"></app-country-flag>
                      <div class="currency-info">
                        <span class="currency-code">{{ currency.code }}</span>
                        <span class="currency-name">{{ currency.name }}</span>
                      </div>
                    </div>
                    <div class="currency-checkbox" [class.checked]="selectedCurrency?.code === currency.code"></div>
                  </li>
                  <li *ngIf="filteredCurrencies.length === 0 && !isCurrenciesLoading" class="no-results">
                    {{ t('noCurrenciesFound') }}
                  </li>
                </ng-container>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <label for="timezone" class="form-label">{{ t('timezone') }}</label>
          <div class="common-drop-down dropdown">
            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-button"
              data-bs-toggle="dropdown" aria-expanded="false">
              {{
              selectedTimezone ? (selectedTimezone.utcOffsetStr + ' - ' + selectedTimezone.name) : t('selectTimezone')
              }}
              <img src="assets/images-fuel/arrowDownIcon.svg" alt="">
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdown-button">
              <li *ngFor="let timezone of timezones"><a class="dropdown-item" (click)="selectedTimezone = timezone">
                  {{ timezone.utcOffsetStr + ' - ' +
                  timezone.name }}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-6">
          <label for="datetimeFormat" class="form-label">{{ t('dateTimeFormat') }}</label>
          <div class="common-drop-down dropdown">
            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-button"
              data-bs-toggle="dropdown" aria-expanded="false">
              {{
              selectedDateTimeFormat ? selectedDateTimeFormat.toUpperCase() : t('selectFormat')
              }}
              <img src="assets/images-fuel/arrowDownIcon.svg" alt="" *ngIf="!selectedDateTimeFormat">
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdown-button">
              <li *ngFor="let dateTimeFormat of dateTimeFormats"><a class="dropdown-item"
                  (click)="selectedDateTimeFormat = dateTimeFormat">{{ dateTimeFormat.toUpperCase() }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="action-group my-4">
    <div class="action-buttons d-flex justify-content-between gap-4">
      <button type="button" class="btn btn-outline-danger flex-grow-1" (click)="closeModal()"
        [disabled]="isSubmitting">{{ t('noCancel') }}</button>
      <button type="button"
        class="btn btn-danger flex-grow-1 btn-update-driver d-flex justify-content-center align-items-center position-relative gap-2"
        (click)="submit()" [disabled]="isSubmitting">
        <span>{{ t('yesSubmit') }}</span>
      </button>
    </div>
  </div>
</div>
</ng-container>
